/*
 * Created by alex@hackerbay.com on 3.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Button, Card, CardBody, Col, Container, Media, Row} from "reactstrap";
import Subtitle from "./Subtitle";

import iconTechnician from "../media/icons/technician.svg"


class StatusBox extends React.Component {
    constructor(props){
        super(props);
    }
    /*
        #Props
        - mainText (First line of text)
        - subText (Optional - second line of text)
        - verboseSubText (Optional - If supplied, second line of text will be full width and img will be smaller. Subtext prop will not be used)
        - buttonTextResource
        - buttonOnClick
        - imgUrl
        - containerClass (Optional - CSS Override class to change the appearance of the background)
     */

    render() {
        let button;
        if(this.props.buttonOnClick){
            button = <Button className={"button-red"} onClick={this.props.buttonOnClick}>{i18n.t(this.props.buttonTextResource, this.props)}</Button>;
        }else{
            button = <span>{i18n.t("cannot_be_changed")}</span>
        }
        let body;
        if(this.props.verboseSubText){
            body =
                <Row>
                    <Col xs={8}>
                        <Row>
                            <Col xs={2}>
                                <img
                                    className={"status-box-img-small"}
                                    //src={this.props.imgUrl}
                                    src={iconTechnician}
                                />
                            </Col>
                            <Col xs={10}>
                                <b>{i18n.t(this.props.mainText, this.props)}</b>
                            </Col>
                        </Row>
                        <Row>
                            <p>{i18n.t(this.props.verboseSubText, this.props)}</p>
                        </Row>
                    </Col>
                    <Col xs={4}>
                        {button}
                    </Col>
                </Row>
        }else{
            body = <Row>
                <Col xs={3}>
                    <img
                        //src={this.props.imgUrl}
                        src={iconTechnician}
                    />
                </Col>
                <Col xs={5}>
                    <Row>
                        <p>{i18n.t(this.props.mainText, this.props)}</p>
                    </Row>
                    <Row>
                        <b>{i18n.t(this.props.subText, this.props)}</b>
                    </Row>
                </Col>
                <Col xs={4}>
                    {button}
                </Col>
            </Row>
        }
        return <Container>
            <Row className={this.props.containerClass}>
                <Col>
                    {body}
                </Col>
            </Row>
        </Container>
    }
}

export default translate("translations")(StatusBox);